import { useTheme, THEMES } from "../context/ThemeContext";
import { Sun, Moon, Sparkle } from "@phosphor-icons/react";

const ICON = { light: Sun, dark: Moon, accent: Sparkle };

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  return (
    <div data-testid="theme-switcher" className="flex items-center gap-1 p-1 rounded-full glass">
      {THEMES.map((t) => {
        const Icon = ICON[t];
        const active = theme === t;
        return (
          <button
            key={t}
            data-testid={`theme-${t}`}
            onClick={() => setTheme(t)}
            title={t}
            className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200 ${
              active ? "brand-gradient text-white shadow-lg scale-105" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon size={15} weight={active ? "fill" : "bold"} />
          </button>
        );
      })}
    </div>
  );
}
